import React, { useEffect } from "react";
import wsManager from "api/ws/websocketManager";
import { useAppSelector } from "store";
import TeamSuspendedScreen from "./TeamSuspendedScreen";

/**
 * STRIPE P5-F2 (PD7): while the session's team is suspended, the app — and the WebSocket provider inside it, whose
 * handshake v3 closes with "team_suspended" — is not mounted at all; the suspended-team screen stands in its place.
 *
 * STRIPE P6 F-c: unmounting the provider is not enough. The manager is a singleton that deliberately survives its
 * provider's unmount (P1-1), and v3's pre-accept refusal reaches the browser as a 1006, not an auth close code, so it would
 * keep reconnecting for as long as the screen is up. Stop it here. "Check again" reloads the app on a restored team, and
 * a fresh provider connects again.
 */
const SuspendedGate = ({ children }: { children: React.ReactNode }) => {
  const teamSuspended = useAppSelector((state) => state.common.teamSuspended);

  useEffect(() => {
    if (teamSuspended) wsManager.disconnect();
  }, [teamSuspended]);

  return teamSuspended ? <TeamSuspendedScreen /> : <>{children}</>;
};

export default SuspendedGate;
